export enum EnvironmentEnum {
  DEVELOPMENT = 'DEVELOPMENT',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
}

type IConfig = {
  API_URL: string;
  WS_URL: string;
  TICKET_ID_PREFIX: string;
  ENVIRONMENT: EnvironmentEnum;
  FMCSA: {
    LINK_FOR_CHECK: string;
  };
  HAULSAFE_PHONE_NUMBER: string;
  SEGMENT_ID: string;
  LOCALHOST_FLEET?: string;
  LOGS_LEVEL: string;
  LOGS_PROVIDERS: string[];
  SENTRY_DSN?: string;
};

const currentEnv =
  process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development';

// eslint-disable-next-line @typescript-eslint/no-var-requires
export default require(`${__dirname}/env.${currentEnv}.ts`).default as IConfig;
